module.exports = __webpack_public_path__ + "img/logo.6a380d84.png";